import React from "react";
import styled from "styled-components";

const Title = styled.h3`
    color: var(--accent-font-color);
    text-transform: uppercase;

    font-size: 1.75rem;
    margin: 2rem 0 0.5rem 0;
`;

const List = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

const Item = styled.span`
    color: var(--dark-font-color);
    background-color: var(--light-background-color);
    border: 1px solid var(--light-background-color);
    border-radius: 25px;
    transition: color 0.5s, background-color 0.5s, border 0.5s;
    display: inline-block;

    padding: 0.25rem 0.5rem;
    margin: 0.5rem 0.75rem;

    :hover {
        color: var(--dark-background-color);
        background-color: var(--light-font-color);
        border-color: var(--light-font-color);
    }
`;


const SkillsList = ({ listTitle, listItems }) => (
    <>
        <Title>{listTitle}</Title>
        <List>
            {listItems.map((skill, index) => (
                <Item key={index}>{skill}</Item>
            ))}
        </List>
    </>
);

export default SkillsList;